 import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './Reducer';
import { listeners, setupListeners } from './Listeners';

// import {
//   materialTransactionsListener,
//   setupMaterialTransactionsListeners,
// } from './INV/MaterialTransactions/MaterialTransactionsListenerMiddleware';

export const store = configureStore({
  reducer: rootReducer,

  // middleware: (getDefaultMiddleware) =>
  // getDefaultMiddleware({
  //   serializableCheck: false,
  //   immutableCheck: false,
  // }).concat(materialTransactionsListener.middleware),

  // middleware: (getDefaultMiddleware) => {
  //   const middleware = getDefaultMiddleware({
  //     serializableCheck: false,
  //     immutableCheck: false,
  //   });

  //   // دمج المستمعات مع الميدلوير
  //   listeners.forEach((listener) => {
  //     middleware.push(listener.middleware); // استخدام push لإضافة المستمعات
  //   });

  //   return middleware; // العودة بالميدلوير المعدل
  // },

  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    });

    // دمج المستمعات مع الميدلوير
    listeners.forEach((listener) => {
      middleware.concat(listener.middleware); // إضافة المستمعات إلى الميدلوير
    });

    return middleware; // العودة بالميدلوير المعدل
  },
});

setupListeners();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
